import { FC } from 'react';

import TableVacancy from '../../../components/table/recruiting/tableVacancyList';

import styles from './vacancy.module.scss';

const Vacancy: FC = () => {
	return (
		<div className={styles.vacancy}>
			<TableVacancy />
		</div>
	);
};

export default Vacancy;
